import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { TasksWorkspace } from '@/features/tasks/pages/tasks-workspace'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/tasks/')({
  component: TasksRoute,
})

function TasksRoute() {
  const { workspaceSlug } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <TasksWorkspace workspaceSlug={workspaceSlug} canWrite={workspace.data?.role !== 'viewer'} />
  )
}
